import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Application global loaders.
 * Provides loading state of the application to track in between pages, such as
 * authentication loader awaiting for configuration or patient profile loader.
 */
@Injectable({
  providedIn: 'root',
})
export class AppLoaderService {
  private _profile$ = new BehaviorSubject<boolean>(false);
  private _organization$ = new BehaviorSubject<boolean>(false);

  /**
   * Used to set profile loader
   * @param flag - boolean
   */
  setProfileLoader(flag: boolean): void {
    this._profile$.next(flag);
  }

  /**
   * @returns profile loader
   */
  get profileLoader$() {
    return this._profile$.asObservable();
  }

  /**
   * Used to set organization loader
   * @param flag - boolean
   */
  setOrganizationLoader(flag: boolean): void {
    this._organization$.next(flag);
  }

  /**
   * @returns organization loader
   */
  get organizationLoader$() {
    return this._organization$.asObservable();
  }
}
